import { VendorLoginURL } from "./APIUrls";


const VendorRegistration = async (vendorData) => {
    try {
        const response = await fetch(`${VendorLoginURL}/RegisterVendorLogin`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(vendorData),
        });

        const data = await response.json();

        if (data.isSuccess && data.Message === 'Success') {
            return true;
        } else {
            return false;
        }

    } catch (error) {
        return {
            status: 500,
            data: null,
            success: false,
            message: error.message
        };
    }
    return false;
};


const validateVendorLogin = async (email, password) => {
    try {
        const response = await fetch(`${VendorLoginURL}/ValidateVendorLogin`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ Email: email, Password: password }),
        });

        const data = await response.json();

        if (data.isSuccess) {
            return {
                status: 200,
                data: data.data,
                success: true,
                message: data.Message
            };
        } else {
            return {
                status: 401,
                data: null,
                success: false,
                message: data.Message
            };
        }
    } catch (error) {
        return {
            status: 500,
            data: null,
            success: false,
            message: error.message
        };
    }
};


const getAllVendorEmailandUserName = async () => {
    try {
        const response = await fetch(`${VendorLoginURL}/GetAllVendorEmailandUserName`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const data = await response.json();

        if (data.isSuccess) {
            return {
                status: 200,
                data: data.data,
                success: true,
                message: data.Message
            };
        } else {
            return {
                status: 404,
                data: null,
                success: false,
                message: data.Message
            };
        }
    } catch (error) {
        return {
            status: 500,
            data: null,
            success: false,
            message: error.message
        };
    }
};

const SendOTPforVendorRegistration = async (email, mobile, otp) => {
    try {
        const response = await fetch(`${VendorLoginURL}/SendOTPforVendorRegistration`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ Email: email, Mobile: mobile, OTP: otp }),
        });

        const data = await response.json();

        if (data?.Message === 'MobileAlreadyRegistered') {
            return {
                status: response.status,
                data: data,
                success: false,
                message:  'Failed to send OTP: Mobile number already registered'
            };
        }

        if (data?.Message === 'EmailAlreadyRegistered') {
            return {
                status: response.status,
                data: data,
                success: false,
                message:  'Failed to send OTP: Email already registered'
            };
        }


        if (data?.isSuccess || data?.Message === 'Success' || response.ok) {
            return {
                status: response.status,
                data: data,
                success: true,
                message: data?.Message || 'OTP sent successfully'
            };
        }

        return {
            status: response.status,
            data: data,
            success: false,
            message: data?.Message || 'Failed to send OTP'
        };
    } catch (error) {
        return {
            status: 500,
            data: null,
            success: false,
            message: error.message
        };
    }
};

export { VendorRegistration, validateVendorLogin, getAllVendorEmailandUserName, SendOTPforVendorRegistration };

const checkWhatsAppChatOptionById = async (vendorId) => {
    try {
        const response = await fetch(`${VendorLoginURL}CheckWhatsAppChatOptionVendorLoginById/${vendorId}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ Id: vendorId }),
        });

        const data = await response.json();

        if (data?.isSuccess) {
            return {
                status: response.status,
                data: data.data,
                success: true,
                message: data.Message,
            };
        }

        return {
            status: response.status,
            data: null,
            success: false,
            message: data?.Message || 'Failed to fetch WhatsApp option',
        };
    } catch (error) {
        return {
            status: 500,
            data: null,
            success: false,
            message: error.message,
        };
    }
};

export { checkWhatsAppChatOptionById };